import { bl_fi_mst_sic_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class StandardIndustrialClassificationContainer extends BaseContainerModel {
  bl_fi_mst_sic_hdr: bl_fi_mst_sic_hdr_RowClass = new bl_fi_mst_sic_hdr_RowClass();
}
